const RESULT_TTL_MINUTES = 30;

// Must be called from a user gesture (a file-input change qualifies) —
// browsers ignore Notification.requestPermission() otherwise.
export function requestNotificationPermission(): void {
    if (!("Notification" in window)) return;
    if (Notification.permission === "default") {
        void Notification.requestPermission();
    }
}

// Only fires if the user has actually stepped away (tab hidden) — if they're
// watching it finish, the UI already tells them.
export function notifyImagesReady(): void {
    if (!("Notification" in window)) return;
    if (Notification.permission !== "granted") return;
    if (document.visibilityState === "visible") return;

    new Notification("Your images are ready!", {
        body: `They'll be deleted in ${RESULT_TTL_MINUTES} minutes if you don't come back for them.`,
        icon: "/favicon.png",
    });
}
